module.exports = __webpack_public_path__ + "img/completion_left.eb26c57f.jpg";